module Steps.Step3.Scroll
    ( scrollIntoViewWidget
    , scrollSectionIntoView
    ) where

import Prelude

import Concur.Core (Widget)
import Concur.React (HTML)
import Effect (Effect)
import Effect.Class (liftEffect)

foreign import jsScrollIntoView :: String -> Effect Unit

scrollSectionIntoView :: String -> Effect Unit
scrollSectionIntoView = jsScrollIntoView

scrollIntoViewWidget :: forall a. a -> String -> Widget HTML a
scrollIntoViewWidget state sectionId = do
    liftEffect $ jsScrollIntoView sectionId
    pure state
